import Vue from 'vue';
import Main from "./main.vue";
var ProductionDetailConstructor = Vue.extend(Main);
var instance;
var ProductionDetail = function ProductionDetail(options) {
  options = options || {};
  console.log(options);
  instance = new ProductionDetailConstructor({
    data: {
      id: options.id,
      successFn: options.successFn
    }
  });
  instance.$mount();
  document.body.appendChild(instance.$el);
  instance.visible = true;
  return instance;
};
ProductionDetail.close = function () {
  if (instance && instance.$el) {
    document.body.removeChild(instance.$el);
  }
};
export default ProductionDetail;